var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63017 5.34761L1.46779 0.185324C1.34839 0.0658301 1.189 0 1.01905 0C0.849095 0 0.689707 0.0658301 0.570308 0.185324L0.190134 0.565403C-0.0572476 0.813068 -0.0572476 1.21559 0.190134 1.46288L4.52511 5.79786L0.185324 10.1376C0.0659244 10.2571 0 10.4164 0 10.5863C0 10.7563 0.0659244 10.9156 0.185324 11.0352L0.565498 11.4152C0.684992 11.5347 0.844285 11.6005 1.01424 11.6005C1.18419 11.6005 1.34358 11.5347 1.46298 11.4152L6.63017 6.2482C6.74985 6.12833 6.81559 5.96828 6.81521 5.79814C6.81559 5.62734 6.74985 5.46739 6.63017 5.34761Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.e8942706c55c0c2f35942363624be148.svg";
export { ForwardRef as ReactComponent };